// Simulated production grounding: plausible scalars, pre-reduced (PRD §9–§10).

import { complete } from "../api/model";
import { PRI } from "../api/scheduler";
import { parseModelJSON } from "../lib/json-repair";
import { bus } from "./bus";
import { save } from "./persistence";
import { traceParseOutcome } from "./telemetry";
import { groundingPrompt } from "./prompts";
import { state } from "./state";

export async function fetchGrounding(): Promise<void> {
  try {
    const raw = await complete(groundingPrompt(state.idea), { max: 260, temp: 0.7, priority: PRI.GROUND, kind: "grounding" });
    const { data, parse } = parseModelJSON(raw);
    traceParseOutcome("grounding", parse, raw);
    state.grounding = (data?.metrics || []).slice(0, 6).map((m: any) => ({ k: String(m.k), v: String(m.v) }));
  } catch { state.grounding = []; }
  save();
  bus.emit("render:grounding", {});   // refills chips in place + repaints coverage
}
